import {CheckOutlined} from '@ant-design/icons'
import {Avatar, Typography} from 'antd'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import React from 'react'
import {renderIf, renderSelf} from 'views/Shared'

export const BaseOption = ({
                             title,
                             avatar,
                             description,
                             renderActions = renderSelf,
                           }, index) => (
  <div key={index} className="w-full flex items-center gap-2">
    {renderIf(
      avatar,
      <Avatar size={30} src={avatar}/>
    )}
    <div className="flex flex-1 flex-col truncate">
      <div className="font-bold text-sm text-color-000 truncate leading-snug">
        {title}
      </div>
      {renderIf(
        description,
        <Typography.Text
          ellipsis={true}
          title={description}
          className="text-color-400 text-xs italic leading-tight">
          {description}
        </Typography.Text>
      )}
    </div>
    {renderActions([
      <CheckOutlined key={index + "CheckOutlined"} className="p-2" style={{color: '#38a169'}}/>,
    ])}
  </div>
)

export const InnerWrapper = ({children, selected, ...props}) => (
  <div
    className={classNames(
      'flex flex-col px-2 justify-center border rounded-lg',
      selected && 'py-1'
    )}
    {...(!!props.key ? {key: props.key} : {})}
  >
    {children}
  </div>
)

export const renderBaseOption = (value, withOption = (option) => ({})) => (option, actions) => {
      const checked = actions && value === getId(option)

        return (
        <BaseOption
          title={getTitle(option)}
          description={option?.description}
          renderActions={(action) => renderIf(checked, action)}
          {...(withOption(option) ?? {})}
        />
      )
    }
